export namespace nsDom {
    export function scrollToTop() {
        document.querySelector(':root')?.scrollIntoView({behavior: "smooth", block: 'start'});
    }

    /** Parse `window.location.search` into a key/value map (no dependency on app singletons). */
    export function retrieveGetParameters(): { [key: string]: string } {
        return window.location.search
            .substring(1)
            .split('&')
            .reduce((obj: any, param: string) => {
                const kp = param.split('=');
                const key = kp[0];
                if (key !== undefined) {
                    obj[decodeURIComponent(key)] = decodeURIComponent(kp[1] ?? '');
                }
                return obj;
            }, {})
    }

    export async function waitForElement(selector: string, counter = 60): Promise<HTMLElement> {
        counter--;
        return new Promise((resolve, reject) => {
            if (counter <= 0) {
                return reject(`Could not find element: ${selector}`);
            }
            requestAnimationFrame(() => {
                const el = document.querySelector(selector);
                if (el) {
                    return resolve(el as HTMLElement);
                } else {
                    return resolve(waitForElement(selector, counter));
                }
            })
        })
    }

    export function waitForElementId(elementId: string, counter?: number): Promise<HTMLElement> {
        return waitForElement('#' + elementId, counter)
    }
}